<template>
  <div class="helpSignBox">
      <div class="helpcloginCon">
          <div class="bigTitle"  @click="backFn('showa')"><span></span>发票问题与产品费用</div>
          <div class="smallTile"  v-if="showa">
            <p>SaaS平台使用方面以智签平台公布的价格为准，接口使用方面以商务协商的书面协议价格为准。</p>
          </div>
          <div class="bigTitle" @click="backFn('showb')"><span ></span>API合作相关</div>
          <div class="smallTile" v-if="showb">
            <p>智签有API的合作方式，如果您需要，可以留下贵公司公司名和联系方式及所在城市，智签会让专业人员给您详细介绍 </p>
          </div> 
          <div class="bigTitle" @click="backFn('showc')"><span ></span>如何联系我们</div>
          <div class="smallTile"  v-if="showc">
            <p>我们的地址：北京市朝阳区望京东路8号锐创国际中心A座5层</p>
            <p>我们的电话：010-86208512</p>
            <p>我们的邮箱：bd@xcontract.cn</p>
          </div> 
      </div>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        showa:false,
        showb:false,
        showc:false,
        showd:false,
      }
    },
    methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
  }
</script>
<style lang="scss">
.helpSignBox{
  .smallTile{
    p{
      color:rgb(150,150,150)!important;
    }
  }
}
</style>
